// extracted by mini-css-extract-plugin
export default {"list":"ContactInfoList_list__prmMx","separatorBorder":"ContactInfoList_separatorBorder__PhqTr"};